import VSelectVoucher from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectVoucher', VSelectVoucher),
};
